import { render, staticRenderFns } from "./ProtectedView.vue?vue&type=template&id=0c63c5f2&"
import script from "./ProtectedView.vue?vue&type=script&lang=js&"
export * from "./ProtectedView.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports